'use client';

import { usePageViewTracking } from '../../hooks/usePageViewTracking';

export function PageViewTracking() {
    usePageViewTracking();

    return null;
}
